import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './ErrorBoundary';
import reportWebVitals from './reportWebVitals';

/*
 * Browser translation fix.
 * When a visitor's browser translates the page (Chrome / Safari "Translate to
 * Hungarian", or our own Google Translate switcher), it swaps React's text
 * nodes for <font> tags. The next time React updates that text (the live
 * ticker, market clocks, etc.) it calls removeChild / insertBefore on a node
 * that is no longer there, throws, and the whole page goes blank.
 * These two guards make React skip the missing node instead of crashing.
 * (Known React issue: github.com/facebook/react/issues/11538)
 */
if (typeof Node === 'function' && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) {
      if (console) console.warn('Skipped removeChild on a node moved by translation', child);
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };
  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      if (console) console.warn('Skipped insertBefore on a node moved by translation', referenceNode);
      return newNode;
    }
    return originalInsertBefore.apply(this, arguments);
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

reportWebVitals();
